module.exports = __webpack_public_path__ + "media/directory/weekend_icon-a0d6d2ad.svg";